// pages/quickbooks/success.jsx
import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Container,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Icon from "components/icon";
import UserLayout from "components/layouts/UserLayout";

const QuickBooksSuccess = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleGoToDashboard = () => {
    navigate("/quickbooks");
  };

  const handleConfigureSync = () => {
    navigate("/quickbooks"); // Or wherever your sync settings are
  };

  return (
    <UserLayout contentHeightFixed={false} activeLink="QuickBooks">
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Card
          sx={{
            borderRadius: 2,
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            overflow: "hidden",
          }}
        >
          <CardContent sx={{ p: 6, textAlign: "center" }}>
            {/* Success Icon */}
            <Box
              sx={{
                display: "inline-flex",
                backgroundColor: "#E8F5E9",
                borderRadius: "50%",
                width: 80,
                height: 80,
                alignItems: "center",
                justifyContent: "center",
                mb: 3,
              }}
            >
              <Icon
                icon="hugeicons:checkmark-circle-03"
                width={48}
                height={48}
                style={{ color: "#23A26D" }}
              />
            </Box>

            {/* Success Message */}
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                mb: 2,
                color: "text.primary",
              }}
            >
              QuickBooks Connected Successfully!
            </Typography>

            <Typography
              variant="body1"
              sx={{
                mb: 4,
                color: "text.secondary",
                fontSize: "1.1rem",
                lineHeight: 1.6,
              }}
            >
              Your QuickBooks Online account has been successfully connected. 
              You can now sync your financial data between Cleri and QuickBooks.
            </Typography>

            {/* Next Steps */}
            <Box
              sx={{
                backgroundColor: "#F8F9FA",
                borderRadius: 2,
                p: 3,
                mb: 4,
                textAlign: "left",
              }}
            >
              <Typography
                variant="h6"
                sx={{ mb: 2, fontWeight: 600, color: "text.primary" }}
              >
                Next Steps:
              </Typography>
              <Box component="ul" sx={{ pl: 2, m: 0 }}>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                  Configure your sync settings to control what data gets synchronized
                </Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>
                  Set up your chart of accounts mapping
                </Typography>
                <Typography component="li" variant="body1">
                  Run an initial sync to bring in your existing data
                </Typography>
              </Box>
            </Box>

            {/* Action Buttons */}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Button
                variant="outlined"
                color="primary"
                size="large"
                onClick={handleGoToDashboard}
                startIcon={<Icon icon="hugeicons:arrow-left" width={20} height={20} />}
                sx={{ minWidth: 200 }}
              >
                Back to Dashboard
              </Button>
              
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleConfigureSync}
                startIcon={<Icon icon="hugeicons:settings" width={20} height={20} />}
                sx={{ minWidth: 200 }}
              >
                Configure Sync
              </Button>
            </Box>

            {/* Quick Tips */}
            <Box
              sx={{
                mt: 5,
                pt: 3,
                borderTop: `1px solid ${theme.palette.divider}`,
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "text.secondary", fontStyle: "italic" }}
              >
                💡 <strong>Tip:</strong> Make sure to run an "Initial Sync" to import 
                all your existing QuickBooks data into Cleri for the first time.
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </UserLayout>
  );
};

export default QuickBooksSuccess;